<template>
  <div class="flex items-center gap-x-2">
    <!-- Light / dark mode button with icon -->
    <UButton
      class="rounded-full"
      variant="ghost"
      :icon="
        isDark
          ? 'line-md:moon-twotone-alt-loop'
          : 'line-md:moon-alt-to-sunny-outline-loop-transition'
      "
      @click="isDark = !isDark"
    />
  </div>
</template>

<script lang="ts" setup>
const colorMode = useColorMode();

const isDark = computed({
  get() {
    return colorMode.value === "dark";
  },
  set(_isDark) {
    colorMode.preference = _isDark ? "dark" : "light";
  },
});
</script>

<style></style>
